import { lazy, Suspense } from "react";
import TopBar from "@/components/TopBar";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import { homeFaqs } from "@/lib/faq-data";
import SEO from "@/components/SEO";
import { business } from "@/lib/business";
import { services } from "@/lib/services-data";

/*
 * Everything below the hero is split out. These sections are the only reason
 * framer-motion sat in the homepage's critical path, and none of them is
 * visible on first paint. They still mount immediately after — not gated on
 * scrolling — so crawlers and assistive technology see the full page.
 */
const ServicesSection = lazy(() => import("@/components/ServicesSection"));
const WhyChooseUs = lazy(() => import("@/components/WhyChooseUs"));
const ReviewWidget = lazy(() => import("@/components/ReviewWidget"));
const ServiceAreas = lazy(() => import("@/components/ServiceAreas"));
const FAQSection = lazy(() => import("@/components/FAQSection"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        path="/"
        title="Landscaping & Masonry in Wakefield MA | NIMAR"
        description="NIMAR Landscaping & Masonry: lawn care, patios, retaining walls, repointing and full landscape design across Wakefield MA and Greater Boston. Free estimates."
        schema={[
          {
            "@type": "WebSite",
            "@id": `${business.domain}/#website`,
            url: business.domain,
            name: business.name,
            publisher: { "@id": `${business.domain}/#organization` },
          },
          {
            "@type": "FAQPage",
            mainEntity: homeFaqs.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          },
          {
            "@type": "ItemList",
            name: "Landscaping and masonry services",
            itemListElement: services.map((s, i) => ({
              "@type": "ListItem",
              position: i + 1,
              name: s.title,
              url: `${business.domain}/services/${s.slug}`,
            })),
          },
        ]}
      />
      <TopBar />
      <Navbar />
      <main>
        <HeroSection />
        <Suspense fallback={null}>
          <ServicesSection />
          <WhyChooseUs />
          <ReviewWidget />
          <ServiceAreas />
          <FAQSection />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
